module.exports = __webpack_public_path__ + "static/img/02.01d0262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/02.png
// module id = uceM
// module chunks = 0